var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum4Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8115,
    cy: 16.9863,
    r: 16,
    fill: "#1167ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.855 18.4263H17.45V16.1613C17.45 15.5163 17.495 14.5113 17.525 13.8513H17.465C17.195 14.4513 16.895 15.0663 16.58 15.6663L14.855 18.4263ZM17.45 22.9863V20.1063H12.71V18.6063L16.85 11.8713H19.505V18.4263H20.81V20.1063H19.505V22.9863H17.45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum4Blue);
export default __webpack_public_path__ + "static/media/icon_circleNum_4_blue.f4e579d05516c5b2ce1588d059a28407.svg";
export { ForwardRef as ReactComponent };